import React from 'react';
import AdminLayout from './AdminLayout';
import ModulePermissionsTab from '../../components/ModulePermissionsTab';

export default function AdminModulesPage() {
    return (
        <AdminLayout title="Modules" description="Manage module permissions and access">
            <ModulePermissionsTab />
        </AdminLayout>
    );
}
